// https://vuex.vuejs.org/en/mutations.html
import { set } from '@/utils/vuex'

export default {
  setOrgs: set('orgs'),
  setUsers: set('users'),
  setVehiType: set('vehiType'),
  setcontactContext: set('contactContext'),
  setContactContext: (state, context) => {
      state.contactContext = context;
  },
  setQuickSearchResults: (state, res) => {
    state.quickSearchResults = res;
  },
  setQuickSearchPayload: (state, payload) => {
    state.quickSearchPayload = payload;
  },
  updateQuickSearchPage: (state, page) => {
    state.quickSearchPayload.pageNum = page;
  }
}
